export default __webpack_public_path__ + "media/images/portfolio/width-600/portfolio-7-b123d149d9f5a75d8dfbb13ee30eced9.jpg";